import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import NewChange from "@/pages/NewChange";
import JobDetail from "@/pages/JobDetail";
import { AuditPage, JobsPage, ReleasesPage } from "@/pages/Lists";
import Vault from "@/pages/Vault";
import Settings from "@/pages/Settings";
import Alerts from "@/pages/Alerts";
import Spend from "@/pages/Spend";
import AIAdmin from "@/pages/AIAdmin";

function Gate() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm text-slate-500">Checking session…</div>;
  if (!user) return <Login />;
  return <Shell />;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="bottom-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route element={<Gate />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/projects/:id/change" element={<NewChange />} />
            <Route path="/jobs" element={<JobsPage />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/releases" element={<ReleasesPage />} />
            <Route path="/vault" element={<Vault />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/spend" element={<Spend />} />
            <Route path="/ai" element={<AIAdmin />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
